<ion-radio-group [value]="CreateActionType.GAME" (ionChange)="select($event.detail.value)">
  <div class="or-d-flex or-head-sm or-flex-col">
    <div
      class="or-align-items-center or-d-flex or-justify-content-evenly or-w-100-pc"
      [ngClass]="
        selected() === CreateActionType.GAME ? 'is-active or-bg-focus or-color-main-1' : 'is-no-active or-bg-white'
      ">
      <ion-radio [value]="CreateActionType.GAME" class="or-mx-20-px" labelPlacement="end" alignment="center">
        <div class="or-d-flex or-flex-col">
          <div
            class="or-head-md or-mb-4-px"
            [ngClass]="selected() === CreateActionType.GAME ? 'or-color-main-1' : 'or-color-black'">
            Gierka
          </div>
          <div class="or-note-sm white-space-normal">
            Szukasz graczy na już lub chcesz stworzyć powtarzalną gierkę dla swoich ludzi? Stwórz gierkę!
          </div>
        </div>
      </ion-radio>
    </div>

    <div
      class="or-align-items-center or-d-flex or-justify-content-evenly or-mt-12-px or-w-100-pc"
      [ngClass]="
        selected() === CreateActionType.TEAM ? 'is-active or-bg-focus or-color-main-1' : 'is-no-active or-bg-white'
      ">
      <ion-radio [value]="CreateActionType.TEAM" class="or-mx-20-px" labelPlacement="end" alignment="center">
        <div class="or-d-flex or-flex-col">
          <div
            class="or-head-md or-mb-4-px"
            [ngClass]="selected() === CreateActionType.TEAM ? 'or-color-main-1' : 'or-color-black'">
            Grupka
          </div>
          <div class="or-note-sm white-space-normal">
            Masz swoją ekipę i chcesz ją przenieść do Orlikfy? Stwórz swoją grupkę!
          </div>
        </div>
      </ion-radio>
    </div>
  </div>
</ion-radio-group>
